// src/components/Footer.jsx
import React from "react";
import { FaFacebookF, FaInstagram, FaTiktok } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import {
  HiOutlineLocationMarker,
  HiOutlineMail,
  HiOutlinePhone,
} from "react-icons/hi";
import { MdAccessTime } from "react-icons/md";
import { Link } from "react-router-dom";
import logo from "../../assets/logo2.jpg";
const Footer = () => {
  const socials = [
    { Icon: FaFacebookF, href: "https://facebook.com", label: "Facebook" },
    { Icon: FaXTwitter, href: "https://x.com/gameportx", label: "X" },
    {
      Icon: FaInstagram,
      href: "https://www.instagram.com/gameportng?igsh=MTZqMmcyOTQydmlsdA==",
      label: "Instagram",
    },
    {
      Icon: FaTiktok,
      href: "https://vm.tiktok.com/ZS9JtHQkGuPpv-tLiw0/",
      label: "TikTok",
    },
  ];

  const quickLinks = [
    { label: "Home", to: "/" },
    { label: "Shop Consoles", to: "/consoles" },
    { label: "About Us", to: "/about" },
    { label: "Contact", to: "/contact" },
  ];

  const customerLinks = [
    { label: "My Account", to: "/profile" },
    { label: "Shopping Cart", to: "/cart" },
    { label: "Track Order", to: "/track-order" },
    { label: "Returns & Refunds", to: "/returns" },
    { label: "FAQs", to: "/faqs" },
  ];

  return (
    <footer className="bg-white border-t border-gray-100 overflow-hidden">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8 pt-12 sm:pt-16 pb-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10 mb-10 sm:mb-12">
          {/* Column 1 */}
          <div className="space-y-5">
            <Link
              to="/"
              className="cursor-pointer flex items-center text-2xl font-bold tracking-tighter"
            >
              {/* <span className="text-gray-900">Game</span>
              <span className="text-[#E00A0C]">Port</span>
              <span className="text-gray-900">NG</span> */}
              <img src={logo} alt="" className="h-48 w-48  object-contain" />
            </Link>

            <p className="text-sm leading-relaxed text-gray-600">
              Your ultimate destination for gaming consoles, accessories, and
              the latest gaming gear in Nigeria.
            </p>

            <div className="flex gap-3">
              {socials.map(({ Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={label}
                  className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center
                    text-gray-600 hover:bg-[#E00A0C] hover:text-white transition
                    focus:outline-none focus-visible:ring-2 focus-visible:ring-[#E00A0C]/30"
                >
                  <Icon size={15} />
                </a>
              ))}
            </div>
          </div>

          {/* Column 2 */}
          <div>
            <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-5">
              <span className="border-b-2 border-[#E00A0C] pb-1 inline-block">
                Quick Links
              </span>
            </h3>

            <ul className="space-y-3">
              {quickLinks.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-gray-600 hover:text-[#E00A0C] text-sm flex items-center gap-2 font-medium
                      focus:outline-none focus-visible:ring-2 focus-visible:ring-[#E00A0C]/30 rounded"
                  >
                    <span className="text-xs">{">"}</span>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3 */}
          <div>
            <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-5">
              <span className="border-b-2 border-[#E00A0C] pb-1 inline-block">
                Customer Service
              </span>
            </h3>

            <ul className="space-y-3">
              {customerLinks.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-gray-600 hover:text-[#E00A0C] text-sm flex items-center gap-2 font-medium
                      focus:outline-none focus-visible:ring-2 focus-visible:ring-[#E00A0C]/30 rounded"
                  >
                    <span className="text-xs">{">"}</span>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4 */}
          <div>
            <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-5">
              <span className="border-b-2 border-[#E00A0C] pb-1 inline-block">
                Contact Us
              </span>
            </h3>

            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <HiOutlineLocationMarker className="mt-1 shrink-0 text-[#E00A0C]" />
                <span className="text-gray-600 text-sm leading-relaxed break-words">
                  18 Simbiat Abiola Way, Beside Jara Mall, Computer Village,
                  Ikeja, Lagos
                </span>
              </li>
<li className="flex items-center gap-3">
    <HiOutlinePhone className="shrink-0 text-[#E00A0C]" />
                <a
                  href="tel:+2348125156566"
                  className="text-sm font-medium text-[#E00A0C] hover:opacity-90
                    focus:outline-none focus-visible:ring-2 focus-visible:ring-[#E00A0C]/30 rounded"
                >
                  +234 812 515 6566
                </a>
</li>
              <li className="flex items-center gap-3">
                
                <HiOutlinePhone className="shrink-0 text-[#E00A0C]" />
                <a
                  href="tel:+2348033895501"
                  className="text-sm font-medium text-[#E00A0C] hover:opacity-90
                    focus:outline-none focus-visible:ring-2 focus-visible:ring-[#E00A0C]/30 rounded"
                >
                  +234 803 389 5501
                </a>
               
              </li>

              <li className="flex items-center gap-3">
                <HiOutlineMail className="shrink-0 text-[#E00A0C]" />
                <a
                  href="mailto:info@gameportng.com"
                  className="text-sm text-[#E00A0C] hover:opacity-90 break-all
                    focus:outline-none focus-visible:ring-2 focus-visible:ring-[#E00A0C]/30 rounded"
                >
                  info@gameportng.com
                </a>
              </li>

              <li className="flex items-center gap-3">
                <MdAccessTime className="shrink-0 text-[#E00A0C]" />
                <span className="text-gray-600 text-sm">
                  Mon - Sat: 9AM - 8PM
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-100 pt-6 sm:pt-8 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-gray-500">
          <p>© 2026 GamePortNG. All rights reserved.</p>

          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2">
            <Link
              to="/privacy"
              className="hover:text-[#E00A0C] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#E00A0C]/30 rounded"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="hover:text-[#E00A0C] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#E00A0C]/30 rounded"
            >
              Terms of Service
            </Link>
            <Link
              to="/sitemap"
              className="hover:text-[#E00A0C] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#E00A0C]/30 rounded"
            >
              Website Map
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
